(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.__tnoOverlayQuickAdd) {
    window.__tnoOverlayQuickAdd = true;

    function positionTnoQuickAdds(scope = document) {
      scope.querySelectorAll('product-card:has([data-tno-card-quick-add])').forEach(card => {
        const overlay = card.querySelector('[data-tno-card-quick-add]');
        const image = card.querySelector('.product-card__content img');
        if (!overlay || !image) return;
        const cardRect = card.getBoundingClientRect();
        const imageRect = image.getBoundingClientRect();
        if (imageRect.height < 30) return;
        const bottom = imageRect.bottom - cardRect.top;
        const imageHeight = imageRect.height;
        overlay.style.setProperty('--tno-qa-top', Math.round(bottom - 8) + 'px');
        overlay.style.setProperty('--tno-qa-image-height', Math.max(120, Math.floor(imageHeight - 12)) + 'px');
      });
    }

    let scheduled = false;
    function queuePosition() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        positionTnoQuickAdds();
      });
    }
    queuePosition();
    window.addEventListener('load', queuePosition);
    window.addEventListener('resize', queuePosition, { passive: true });
    document.addEventListener('shopify:section:load', queuePosition);
    document.addEventListener('load', e => {
      if (e.target instanceof HTMLImageElement) queuePosition();
    }, true);
    new MutationObserver(queuePosition).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', async event => {
      // Let Klaviyo handle its own injected collection trigger click.
      if (event.target.closest('.klaviyo-button-container')) return;
      const quickAdd = event.target.closest('[data-tno-card-quick-add]');
      if (quickAdd) {
        event.preventDefault();
        event.stopPropagation();
        const summary = event.target.closest('.tno-card-quick-add__toggle');
        if (summary) {
          const details = summary.closest('details');
          details.open = !details.open;
          return;
        }
      }
      const close = event.target.closest('.tno-card-quick-add__close');
      if (close) {
        const details = close.closest('details');
        if (details) details.open = false;
        return;
      }
      const notify = event.target.closest('[data-tno-notify-variant]');
      if (notify) {
        event.preventDefault();
        event.stopPropagation();
        const card = notify.closest('product-card');
        const injectedTrigger = card?.querySelector('.klaviyo-button-container .klaviyo-bis-trigger, .klaviyo-button-container a, .klaviyo-button-container button');
        const selectedVariantId = notify.dataset.tnoNotifyVariant;
        const status = notify.closest('details')?.querySelector('.tno-card-quick-add__status');
        /* Only use Klaviyo's own collection trigger when its integration has injected one.
           Klaviyo itself owns the variant data in that integration. */
        if (card?.querySelector('[data-tno-single-variant="true"]') && injectedTrigger && !injectedTrigger.hasAttribute('disabled')) {
          injectedTrigger.click();
          if (status) status.textContent = '';
        } else {
          /* Preserve correct variant context rather than enrolling in a wrong product.
             On themes where Klaviyo only supports product pages, link to that variant. */
          const productLink = card?.querySelector('.product-card__link')?.href || '';
          const url = new URL(productLink || window.location.href, window.location.origin);
          url.searchParams.set('variant', selectedVariantId);
          window.location.assign(url.toString());
        }
        return;
      }
      const size = event.target.closest('[data-tno-variant-id]');
      if (!size || size.disabled) {
        if (!event.target.closest('[data-tno-card-quick-add]')) {
          document.querySelectorAll('.tno-card-quick-add__details[open]').forEach(el => el.open = false);
        }
        return;
      }
      event.preventDefault();
      if (size.dataset.busy === 'true') return;
      const details = size.closest('details');
      const status = details?.querySelector('.tno-card-quick-add__status');
      size.dataset.busy = 'true';
      size.disabled = true;
      if (status) status.textContent = 'ADDING...';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(size.dataset.tnoVariantId), quantity: 1 })
        });
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || item.message || 'Could not add item');
        // Horizon native cart update event refreshes its cart components.
        const cartResponse = await fetch(root + 'cart.js', {
          headers: { 'Accept': 'application/json' }, cache: 'no-store'
        });
        if (!cartResponse.ok) throw new Error('Could not load cart');
        const cart = await cartResponse.json();
        const { CartUpdateEvent } = await import('@theme/events');
        document.dispatchEvent(new CartUpdateEvent(cart, 'tno-quick-add', {
          itemCount: cart.item_count,
          source: 'tno-quick-add',
          sections: {}
        }));
        document.querySelectorAll('[data-tno-cart-open]').forEach(button => {
          button.setAttribute('aria-label', 'Open cart, ' + cart.item_count + ' items');
          let badge = button.querySelector('.tno-count');
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'tno-count';
              button.appendChild(badge);
            }
            badge.textContent = cart.item_count;
          } else {
            badge?.remove();
          }
        });
        details.open = false;
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          const nativeTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
          if (nativeTrigger) nativeTrigger.click();
          else throw new Error('Horizon cart drawer is not loaded');
        }
        if (status) status.textContent = '';
        return;
      } catch (error) {
        if (status) status.textContent = error.message || 'PLEASE TRY AGAIN';
      } finally {
        size.disabled = false;
        delete size.dataset.busy;
      }
    }, true);

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        document.querySelectorAll('.tno-card-quick-add__details[open]').forEach(el => el.open = false);
      }
    });
    document.addEventListener('toggle', event => {
      if (!event.target.matches?.('.tno-card-quick-add__details') || !event.target.open) return;
      document.querySelectorAll('.tno-card-quick-add__details[open]').forEach(el => {
        if (el !== event.target) el.open = false;
      });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
